import formatValue from './FormatValues';

export function isIndicatorPercentageFormat(format: string | undefined | null): boolean {
  return String(format ?? '').toLowerCase() === 'percentage';
}

/**
 * Engine stores percentage as decimals (0.15 = 15%). Number/currency use raw values.
 * Scale only at display time so format toggles do not multiply stored values repeatedly.
 */
export function blockOutputStoredValueToDisplay(
  rawValue: number | string | null | undefined,
  format: string | undefined | null,
): number {
  const parsed = Number(rawValue);
  if (Number.isNaN(parsed)) return 0;
  return isIndicatorPercentageFormat(format) ? parsed * 100 : parsed;
}

/**
 * `formatProperties` is the indicator's own `format_properties` (measure,
 * decimal_points, thousand_separators, scale, negative_parentheses). Without
 * it this only ever emitted a bare number capped at 2dp, so changing an
 * indicator's currency symbol or decimal places had no visible effect on the
 * grid at all — it looked like the grid wasn't refreshing when in fact the
 * display never read those settings. Callers that don't have them keep the
 * old bare-number behaviour.
 */
export function blockOutputDisplayText(
  rawValue: number | string | null | undefined,
  format: string | undefined | null,
  formatProperties?: Record<string, any> | null,
): string {
  if (rawValue == null || rawValue === '') return '0';
  const display = blockOutputStoredValueToDisplay(rawValue, format);

  if (!formatProperties) {
    // Cap to 2 decimal places (matches default format_properties.decimal_points).
    return Number(display.toFixed(2)).toString();
  }

  return formatValue(display, formatProperties as any);
}
